import { Component, OnInit, Input } from '@angular/core';
import { MailInfo } from '../../../model/mail-info.model';
import { MatchingOffer } from 'src/app/shared/model/matching-offer.model';
import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { RejectReason } from '../../../model/mail-reject-reasons';
@Component({
  selector: 'app-card-header-title',
  templateUrl: './card-header-title.component.html',
  styleUrls: ['./card-header-title.component.scss']
})
export class CardHeaderTitleComponent implements OnInit {
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() page: string;
  @Input() sharedAccountOffers: MatchingOffer[]; // 共通アカウント（USER_CODE）に紐付くオファーを取得
  @Input() offeredMailIds: number[]; // offersの中のmail_id
  @Input() showTooltip = true;
  @Input() rejectReason: RejectReason;
  @Input() haveSkillList: boolean;
  @Input() searchParams: SearchCondition;
  @Input() baseKeywords: Array<String> = [];
  constructor() {}

  ngOnInit() {}

  rejected_keys() {
    const dict = {
      receipt_datetime_search: '日',
      mail_from_search: '送',
      bp_rank_search: '送',
      work_location_search: '所',
      fee_search: '金',
      age_search: '齢',
      ncc_search: '商',
      employment_status_search: '雇',
      country_of_citizenship_search: '国',
      begin_at_search: '始',
      commute_search: '時',
      interview_times_search: '面',
      non_transmited_number_search: '再',
      sender_hash_id_search: 'sender_hash_id_search',
      best_condition_search: 'best_condition_search',
    };
    const rejected: string[] = [];
    for (const [key, value] of Object.entries(this.rejectReason)) {
      if (!value && dict[key]) {
        rejected.push(dict[key]);
      }
    }
    return rejected.join(' : ');
  }

  rejectReasonText() {
    // TODO: タグではrejected_keys()が取得できてない（再送以外）
    // keyが取得できない時は'× : 'じゃなくて、'×'にした方が良いのでは？
    let text = '× : ' + this.rejected_keys();
    text = text.replace( 'sender_hash_id_search', '<i class="crown crown-no_best"></i>' );
    text = text.replace( ' : best_condition_search', '' );
    return text;
  }
}
